import { ITraderAvatarUser } from "src/components-mui/common/trader-avatar/trader-avatar";
import { IAutoCompleteTrader, IUser } from "src/types/common";
import { isDeletedUserStatus } from "src/utils/user-status-util";

export interface ITraderWithProfilePicture extends Pick<IUser, "id" | "nickName" | "firstName" | "lastName" | "isDeleted"> {
    isProfilePictureAvailable: boolean;
    traderImageUrl: string;
}

export const mapTraderToAvatarUser = ({ trader }: { trader: ITraderWithProfilePicture }): ITraderAvatarUser => ({
    id: trader.id,
    nickName: trader.nickName,
    firstName: trader.firstName,
    lastName: trader.lastName,
    isDeleted: trader.isDeleted,
    profilePictureUrl: trader.isProfilePictureAvailable ? trader.traderImageUrl : null,
});

export const mapAutoCompleteTraderToAvatarUser = (trader: IAutoCompleteTrader): ITraderAvatarUser =>
    mapTraderToAvatarUser({
        trader: {
            ...trader,
            id: trader.id ?? trader.nickName,
            isDeleted: isDeletedUserStatus(trader.userStatus),
            traderImageUrl: trader.imageUrl,
        },
    });
